import store from "@/store";

/** @returns { string | null } */
export const getAccessToken = () => store.state.luneAuth.accessToken ?? localStorage.getItem("token") ?? null;
